/**
 * 사람
 */
import { Fragment } from 'react';
import { useLoaderData } from 'react-router-dom';
import Header from '@features/content/Header';
import { apiSearchSlice } from '@features/api/apiSearchSlice';
import { setRequestToSearchParams } from '@utils/index';
import { getLocalData } from '@features/api/apiLocalSlice';
import { ALIAS, CUR_NETWORK, NETWORK } from '@constants/index';
import NoData from '../../components/contents/common/NoData';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { selectL10N, setAlias } from '@features/ui/UiSlice';
import NpUserArticle from '@components/contents/article/NpUserArticle';
import Paging from '@components/contents/common/Paging';
import type { IContentData, ILoaderData, INpUser } from '@type/index';

export const NpUserLoader =
  (dispatch, option: IOption) =>
  async ({ request }): Promise<INpUser | null> => {
    const searchParams = setRequestToSearchParams(request);

    // alias 변경 - searchParams 변경에 사용됨
    dispatch(setAlias(ALIAS.NPUSER));

    if (!searchParams?.keyword) {
      return null;
    }

    return CUR_NETWORK === NETWORK.OPDEV
      ? await getLocalData(ALIAS.NPUSER, searchParams)
      : await dispatch(apiSearchSlice?.endpoints?.getNpUser?.initiate({ option, params: searchParams }));
  };

interface IContentComponentProps {
  data: IContentData<INpUser>;
}
const ContentComponent = ({ data }: IContentComponentProps) => {
  const l10n = useAppSelector(selectL10N);

  return (
    <Fragment>
      <div className="search-content">
        <ul className="column column-2">
          {data?.list.map((item, i) => (
            <li key={i} className="search-item">
              <NpUserArticle item={item} l10n={l10n!} />
            </li>
          ))}
        </ul>
      </div>
      <Paging endPage={data?.pagination?.endPage} showPage={5} l10n={l10n!} />
    </Fragment>
  );
};

const NpUser = () => {
  const { data, isLoading, isError } = (useLoaderData() as ILoaderData<IContentData<INpUser>>) || {};

  console.log('NpUser Data', data);

  if (isError || !Array.isArray(data?.list) || data?.list?.length === 0) {
    return <NoData />;
  }

  return (
    <div className="search-result npuser">
      <Header totalCount={data?.pagination?.total} />
      <ContentComponent data={data} />
    </div>
  );
};

export default NpUser;
